import { RegionLandingPage } from "./RegionLandingPage";
import { landingPages } from "./registry";

const entry = landingPages.find((p) => p.slug === "us-west-coast")!;

export function UsWestCoastPage() {
  return <RegionLandingPage regionKey={entry.regionKey} tag={entry.tag} />;
}
